export default {
  sign: require('./signature.png'),
  topFrame: require('./top.png'),
  bottomFrame: require('./bottom.png'),
  logo: 'https://cdn.karier.mu/assets/home/sekolahmu_logo.svg',
  modal: require('./modal.jpeg'),
  background: require('./background.png'),
  background_1ttd_2logo: 'https://cdn.karier.mu/assets/certificate/background_1ttd_2logo.png',
  background_2ttd_1logo: 'https://cdn.karier.mu/assets/certificate/background_2ttd_1logo.png',
  background_2ttd_2logo: 'https://cdn.karier.mu/assets/certificate/background_2ttd_2logo.jpg',
  background_addon_1ttd_1logo: 'https://cdn.karier.mu/assets/certificate/background_addon_1ttd_1logo.jpg',
  success: require('./success_sertifikat.png'),
  share: require('./share.svg'),
  linkedin: require('./linkedin.png'),
  facebook: require('./facebook.png'),
  twitter: require('./twitter.png'),
  whatsapp: require('./whatsapp.png')
}
